import { Injectable } from '@angular/core';
import {
  IFreatimetro,
  ICreateFreatimetro,
  IQueryParam,
  IUpdateFreatimetro,
  IComando,
  IAlerta,
  ICliente,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { apiBase } from 'src/environments/environment';
import { HelperService } from '../../../auxiliares/helper.service';
import { HttpService } from '../../../auxiliares/http.service';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class FreatimetrosService {
  constructor(private http: HttpService) {}

  // Freatimetros
  public getFreatimetro(id: string): Observable<IFreatimetro> {
    return this.http.get(`${api}/freatimetros/${id}`);
  }
  public getFreatimetros(queryParams?: IQueryParam): Observable<{
    data: IFreatimetro[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/freatimetros`, { params });
  }
  public createFreatimetro(data: ICreateFreatimetro): Observable<IFreatimetro> {
    return this.http.post(`${api}/freatimetros`, data);
  }
  public updateFreatimetro(
    id: string,
    data: IUpdateFreatimetro,
  ): Observable<IFreatimetro> {
    return this.http.put(`${api}/freatimetros/${id}`, data);
  }
  public deleteFreatimetro(id: string): Observable<IFreatimetro> {
    return this.http.delete(`${api}/freatimetros/${id}`);
  }

  // Reportes

  public async exportarReportes(
    queryParams?: IQueryParam,
    filename = 'reportes.xlsx',
  ): Promise<void> {
    const params = HelperService.getQueryParams(queryParams);
    await this.http.getFile(
      `${api}/reportes/exportar/freatimetro`,
      filename,
      params,
    );
  }

  // Comandos

  public solicitarUbicacion(deveui: string): Observable<IFreatimetro> {
    return this.http.post(`${api}/comandos/ubicacion`, { deveui });
  }

  public delComando(id: string): Observable<IComando> {
    return this.http.delete(`${api}/comandos/${id}`);
  }

  // Alertas

  public delAlerta(id: string): Observable<IAlerta> {
    return this.http.delete(`${api}/alertas/${id}`);
  }

  // Parseos
  public estadoEstacion(dato: IFreatimetro) {
    const limite = this.fechaHaceXHoras(13);
    const ultimaComunicacion = dato.ultimaComunicacion
      ? new Date(dato.ultimaComunicacion)
      : null;

    if (!ultimaComunicacion || limite > ultimaComunicacion) {
      return 'Sin reportar';
    }

    return dato.ultimoEstado;
  }

  private fechaHaceXHoras(horas: number) {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    return fecha;
  }

  public conseguidorDeColorPorFreatimetro(
    f: IFreatimetro,
    cliente?: ICliente,
  ): string | undefined {
    const nivelActual = f.ultimoReporte?.reporte?.nivel;

    const NivelActualCalculado = this.calcularAltura(
      nivelActual || 0,
      f.offset || 0,
    );

    const semaforos =
      f?.configuraciones?.coloresNivel ||
      cliente?.configuraciones?.cisterna?.coloresNivel;

    const find = semaforos?.find((semaforo) => {
      return (
        NivelActualCalculado! >= semaforo.valorDesde &&
        NivelActualCalculado! < semaforo.valorHasta
      );
    });
    return find?.color;
  }

  public calcularAltura(v: number, offset: number) {
    // EN CM
    if (offset < 0) {
      return Math.abs(v + offset);
    } else {
      return Math.abs(v - offset);
    }
  }
}
